module.exports = __webpack_public_path__ + "img/A58A0603_min.6fa6cb5c.jpg";